import { SkeletonLoader } from '../loader';

const TableCellBusy = () => (
    <td aria-busy="true" className="fl-table-cell">
        <SkeletonLoader>...</SkeletonLoader>
    </td>
);

export default TableCellBusy;
